// removed by extract-text-webpack-plugin
module.exports = {"thunder":"#6b6e72","wolf":"#dcdee2","eclipse":"#9e9fa5","spacing-medium":"8px","removeContainer":"SettingsRemoveSchoolModal__removeContainer___38kJ0","actionLabel":"SettingsRemoveSchoolModal__actionLabel___27M1J","actionText":"SettingsRemoveSchoolModal__actionText___i7Z9J","subscriptionHeader":"SettingsRemoveSchoolModal__subscriptionHeader___1JLsE","subscription":"SettingsRemoveSchoolModal__subscription___pPhty","subscriptionName":"SettingsRemoveSchoolModal__subscriptionName___hqdMv","leaveGroupNames":"SettingsRemoveSchoolModal__leaveGroupNames___1m4hy"};


//////////////////
// WEBPACK FOOTER
// ./src/settings/components/styles/SettingsRemoveSchoolModal.css
// module id = 2263
// module chunks = 0 1